import { render } from "./proyeksi_practice.vue?vue&type=template&id=5402326f"
import script from "./proyeksi_practice.vue?vue&type=script&lang=js"
export * from "./proyeksi_practice.vue?vue&type=script&lang=js"

import "./proyeksi_practice.vue?vue&type=style&index=0&id=5402326f&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__